import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import ListsFacade from "./Facade/ListsFacade";
import ListContentFilters from "./Models/Filters/ListContentFilters";

export default class Lists {
  private facade: ListsFacade = null;

  constructor(config: SDKConfigurationModel) {
    this.facade = new ListsFacade(config);
  }

  public getListContent = async (
    listId: string,
    filters?: ListContentFilters,
    disableCache?: boolean
  ) => {
    return await this.facade.getListContent(listId, filters, disableCache);
  };
}
